import _ from 'lodash';


/**
 *  upsert is a function that takes an array, a key, and a new value.
 * If the array contains an object with the same key, the object is replaced with the new value.
 * If the array does not contain an object with the same key, the new value is added to the array.
 * This function is useful for updating an array of objects with a unique key.
 * @param {Array} arr
 * @param {Object} key
 * @param {Object} newval
 * @returns {void}
 */
export const upsert = (arr, newval, key) => {
  const index = _.indexOf(arr, _.find(arr, key));
  if (index !== -1) {
    arr.splice(index, 1, newval);
  } else {
    arr.push(newval);
  }
};
